import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetVoucherDetailRequestDto } from "@/modules/voucher/dtos/get-voucher-detail-request-dto";
import type { GetVoucherDetailResponseDto } from "@/modules/voucher/dtos/get-voucher-detail-response-dto";
import { VoucherQueryKeys } from "@/modules/voucher/generators/voucher-query-keys";
import { VoucherService } from "@/modules/voucher/services/voucher-service";

type UseGetVoucherDetailQueryProps = {
  queryParams: GetVoucherDetailRequestDto;
  options?: Omit<UseQueryOptions<GetVoucherDetailResponseDto>, "queryKey">;
};

export const useGetVoucherDetailQuery = ({
  queryParams,
  options
}: UseGetVoucherDetailQueryProps) => {
  return useQuery({
    queryKey: VoucherQueryKeys.getVoucherDetail(queryParams.voucherId).queryKey,
    queryFn: async () =>
      await VoucherService.getVoucherDetail({
        payload: queryParams
      }),
    ...options
  });
};
